import { render, staticRenderFns } from "./exhibition-cret-En.vue?vue&type=template&id=10aa0aa8&scoped=true&"
import script from "./exhibition-cret-En.vue?vue&type=script&lang=js&"
export * from "./exhibition-cret-En.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-cret-En.vue?vue&type=style&index=0&id=10aa0aa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aa0aa8",
  null
  
)

export default component.exports